<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-circle-plus-outline"
            @click="addClick"
          >
            新增
          </el-button>
          <el-button
            type="danger"
            plain
            size="mini"
            icon="el-icon-circle-close"
            @click="delClick('all', ids)"
            :disabled="ids.length < 1 ? true : false"
          >
            删除
          </el-button>
          <input
            type="file"
            id="riskFile"
            accept=".doc,.docx,.xls,.xlsx,.pdf,.ppt"
            @change="fileImportOne($event)"
          />
          <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-bottom-right"
            style="margin-left:10px"
            @click="selectFileImport"
          >
            导入
          </el-button>
          <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-top-right"
            @click="downloadChildrenFile"
            :disabled="tableData.length == 0"
          >
            导出
          </el-button>
          <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-download"
            @click="
              $Common.fileDownloads('files/templates/留守儿童档案模板.xlsx')
            "
          >
            下载模版
          </el-button>
      </div>
      <div class="search_box">
        <el-input
            class="select-input"
            placeholder="请输入学生姓名"
            size="mini"
            clearable
            v-model.trim="searchParams.studentName"
          ></el-input
          >&nbsp;
          <el-input
            class="select-input"
            placeholder="请输入帮扶老师姓名"
            size="mini"
            clearable
            v-model.trim="searchParams.terName"
          ></el-input
          >&nbsp;
          <el-select
            class="select-input"
            v-model="searchParams.status"
            placeholder="父母外出情况"
            size="mini"
            clearable
          >
            <el-option
              v-for="(value, key) in $store.state.select.parentSituation"
              :key="key"
              :label="value.nameOne"
              :value="value.id"
            ></el-option> </el-select
          >&nbsp;
          <el-button
            size="mini"
            plain
            type="primary"
            icon="el-icon-search"
            @click="searchData"
            >搜索</el-button
          >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          v-loading="tableLoading"
          @selection-change="selectActionData"
        >
          <el-table-column type="selection" width="40" align="center"> </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                searchParams.pageSize * (searchParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="studentName"
            label="学生姓名"
            width="120"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="className"
            label="班级"
            width="120"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="guardianName"
            label="临时监护人姓名"
            width="160"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="guardianPhone"
            label="临时监护人联系方式"
            width="160"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="helpTeacherName"
            label="帮扶老师姓名"
            width="120"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="helpTeacherPhone"
            label="帮扶老师联系方式"
            width="160"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="name3"
            label="父母外出情况"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="rowData">
              {{
                $store.state.select.parentSituation[rowData.row.parentGoOutStatus]
                  .nameOne
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="date1"
            label="创建时间"
            show-overflow-tooltip
            width="120"
            align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDate(rowData.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" 
            align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="editClick(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delClick('single', [scope.row.id])"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-edit
      :drawerShow="drawerShow"
      :drawerType="drawerType"
      @handleClose="handleClose"
      @saveData="saveData"
      :initialData="addOrEditData"
    ></add-or-edit>
  </div>
</template>

<script>
import AddOrEditChildern from "./components/AddOrEditChildern";
export default {
  name: "",
  components: {
    "add-or-edit": AddOrEditChildern
  },
  props: {},
  data() {
    return {
      searchParams: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1,
        studentName: "", //学生名称
        terName: "", //帮扶老师姓名
        status: "" //父母外出情况 0父亲外出 1母亲外出 2父母均外出
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      ids: [],
      drawerShow: false,
      drawerType: "add",
      addOrEditData: {
        id: "", //编号（编辑时传）
        schoolId: this.$store.state.schoolId, //学校id
        studentName: "", //学生名称
        className: "", //班级名称
        gender: "", //性别 0男 1女
        studentBirthday: "", //学生生日
        parentName: "", //家长姓名
        parentPhone: "", //家长联系电话
        parentGoOutStatus: "", //父母外出情况 0父亲外出 1母亲外出 2父母均外出
        parentGoOutAddr: "", //父母外出地址
        parentGetHomeNum: "", //父母外出后回家频次
        parentWork: "", //父母外出从事工作
        guardianName: "", //临时监护人
        guardianRelationship: "", //与临时监护人关系
        guardianPhone: "", //临时监护人联系方式
        guardianAddr: "", //临时监护人居住地址
        helpTeacherName: "", //帮扶老师姓名
        helpTeacherPhone: "", //帮扶老师联系电话
        helpTeacherSub: "", //帮扶老师所教学科
        content: "" //生活情况简介
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 搜索
    searchData() {
      this.searchParams.pageNum = 1;
      this.getList();
    },
    // 获取学生心里健康档案信息列表
    async getList() {
      this.tableLoading = true;
      let req = Object.assign({}, this.searchParams);
      if (req.studentName == "") {
        delete req.studentName;
      }
      if (req.terName == "") {
        delete req.terName;
      }
      let res = await this.$Http.getChildrenList(req);
      this.tableLoading = false;
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 新增
    addClick() {
      this.drawerShow = true;
      this.drawerType = "add";
    },
    // 修改
    editClick(row) {
      this.addOrEditData = Object.assign({}, row);
      this.addOrEditData.studentBirthday =
        parseInt(this.addOrEditData.studentBirthday) * 1000;
      this.drawerShow = true;
      this.drawerType = "edit";
    },
    // 关闭抽屉
    handleClose() {
      this.drawerShow = false;
      this.refearshData();
    },
    // 提交数据(新增或修改)
    saveData() {
      this.drawerShow = false;
      this.getList();
      this.refearshData();
    },
    // 刷新数据
    refearshData() {
      this.addOrEditData = {
        id: "", //编号（编辑时传）
        schoolId: this.$store.state.schoolId, //学校id
        studentName: "", //学生名称
        className: "", //班级名称
        gender: "", //性别 0男 1女
        studentBirthday: "", //学生生日
        parentName: "", //家长姓名
        parentPhone: "", //家长联系电话
        parentGoOutStatus: "", //父母外出情况 0父亲外出 1母亲外出 2父母均外出
        parentGoOutAddr: "", //父母外出地址
        parentGetHomeNum: "", //父母外出后回家频次
        parentWork: "", //父母外出从事工作
        guardianName: "", //临时监护人
        guardianRelationship: "", //与临时监护人关系
        guardianPhone: "", //临时监护人联系方式
        guardianAddr: "", //临时监护人居住地址
        helpTeacherName: "", //帮扶老师姓名
        helpTeacherPhone: "", //帮扶老师联系电话
        helpTeacherSub: "", //帮扶老师所教学科
        content: "" //生活情况简介
      };
    },
    selectActionData(selectData) {
      this.ids = selectData.map((item) => {
        return item.id;
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchParams.pageNum = val || 1;
      this.getList();
    },
    delClick(type, ids) {
      if (type == "all") {
        if (ids.length > 0) {
          this.deleteConfirm(ids);
        } else {
          this.$message({
            message: "请先选择所要删除的学生档案!"
          });
        }
      } else {
        this.deleteConfirm(ids);
      }
    },
    // 删除提示框
    deleteConfirm(ids) {
      this.$confirm("此操作将永久删除学生档案, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delHentalHealth({ ids: ids.toString() });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async delHentalHealth(data) {
      let req = Object.assign({}, data);
      debugger;
      let res = await this.$Http.delChildrenFile(req);
      if (res.code == 200) {
        this.getList();
      } else {
        this.$message({ type: "error", message: res.message || "删除失败" });
      }
    },
    // 选择文件导入
    selectFileImport() {
      document.getElementById("riskFile").click();
    },
    // 导入留守儿童档案
    async fileImportOne(event) {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      var requestData = {
        file: fileUpload
      };
      document.getElementById("riskFile").value = null
      let saveData = await this.$Http.importChildrenFile(requestData, true);
      if (saveData.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功!"
        });
      } else if (saveData.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: saveData.messsage
        });
      }
      this.getList();
    },
    // 导出留守儿童档案
    async downloadChildrenFile() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      this.$Common.exportData(req, "downloadChildrenFile", "留守儿童档案", false);
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.select-input {
  width: 154px;
}
</style>
